import { ApparelProduct, GraphicPlacement, GraphicProduct, IGraphicGDM, IViewBox, PlacementTypes } from "./types/Graphics.t"

export interface GraphicHelperProps {
    graphic: IGraphicGDM
    productID: ApparelProduct
    placementID: PlacementTypes
}

export const GraphicProductData = (props: GraphicHelperProps): GraphicProduct | undefined => {
    const product: GraphicProduct | undefined = props.graphic.product.find(
        (item: GraphicProduct) =>
            item.productID === props.productID
    )
    return product
}

export const GraphicPlacementData = (props: GraphicHelperProps): GraphicPlacement | undefined => {
    const product = GraphicProductData(props)
    const placement: GraphicPlacement | undefined = product?.placement.find(
        (item: GraphicPlacement) => {
            return item.placementID === props.placementID;
        }
    )
    return placement
}

export const GraphicPositionData = (props: GraphicHelperProps): IViewBox | undefined => {
    const placement = GraphicPlacementData(props)
    return placement?.position
}
